// Integrations What's new (/integrations/whats-new): every published
// Integrations newsletter, newest first — Data Configuration, Implementations
// tools and the pipelines behind them (#4235). Same page, format and rules as
// the Super Portal's; its own notes (integrations-releases/published/*.md),
// its own unread dot (the rat in the Integrations nav).

import { Link } from 'react-router-dom';
import WhatsNew, { releaseFeed } from './WhatsNew';
import { INTEGRATIONS_RELEASES } from './integrationsReleases.generated';

export const INTEGRATIONS_RELEASES_SEEN_EVENT = 'integrations:releases-seen';
const FEED = releaseFeed(INTEGRATIONS_RELEASES, 'integrations.releases.seen', INTEGRATIONS_RELEASES_SEEN_EVENT);
export const LATEST_INTEGRATIONS_RELEASE_ID = FEED.latest;
export const hasUnseenIntegrationsRelease = () => FEED.hasUnseen();
export const markIntegrationsReleasesSeen = () => FEED.markSeen();

const INTRO = 'What changed in Data Configuration and the Implementations tools, newest first. Each note says where to '
    + 'find the change and whether anything changes for you. The same notes go to the team by email.';

export default function IntegrationsWhatsNew({ releases = INTEGRATIONS_RELEASES }) {
    return (
        <WhatsNew releases={releases} onSeen={markIntegrationsReleasesSeen} eyebrow="Integrations release notes"
            intro={INTRO} footer={<Link to="/data-config">Open Data Configuration →</Link>} />
    );
}
